import React from "react";
import { MdComputer, MdDarkMode, MdLightMode } from "react-icons/md";

import SegmentedControl from "../SegmentedControl/SegmentedControl";
import { useThemeMode } from "../../../theme/ThemeModeContext";
import { useTranslation } from "react-i18next";

const OPTIONS = [
  { value: "light", labelKey: "theme.light", icon: MdLightMode },
  { value: "dark", labelKey: "theme.dark", icon: MdDarkMode },
  { value: "system", labelKey: "theme.system", icon: MdComputer },
];

const ThemeToggle = ({ compact = false, className = "" }) => {
  const { mode, setMode } = useThemeMode();
  const { t } = useTranslation("common");
  const options = OPTIONS.map(({ labelKey, ...o }) => ({
    ...o,
    label: t(labelKey),
  }));

  return (
    <SegmentedControl
      options={options}
      value={mode}
      onChange={setMode}
      ariaLabel={t("theme.colorTheme")}
      compact={compact}
      className={className}
    />
  );
};

export default ThemeToggle;
